import e from "react";
import { useAction as p } from "../../../hooks/useAction.js";
import { LandingButton as f } from "../../LandingButton/LandingButton.js";
import { useWindowSize as _ } from "../../../../dom/hooks/useWindowSize.js";
import { useNavbar as m } from "../hooks/useNavbar/useNavbar.js";
import { HorizontalScroller as u } from "../../../../common/components/HorizontalScroller/HorizontalScroller.js";
import { RssIcon as v } from "../../../../common/components/Rss/Rss.js";
import a from "../navbar.module.scss.js";
import { useNavigation as E } from "../../Navigation/hooks/useNavigation.js";
function d() {
  const {
    menu: r,
    design: t,
    utmReferral: n
  } = m(), c = (r == null ? void 0 : r.props.socials) ?? [], {
    actionLinks: s
  } = p(
    [],
    (r == null ? void 0 : r.props.sections) ?? [],
    {
      overrideHistory: !0,
      utmReferral: n
    }
  );
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: a.navbar__leftContainer__buttonsWrapper }, /* @__PURE__ */ e.createElement(u, null, s.map(({ action: l, text: o }, i) => /* @__PURE__ */ e.createElement(
    f,
    {
      key: `action-btn-${i}`,
      action: l,
      className: a.navbar__leftContainer__button,
      backgroundColor: "transparent",
      textColor: t == null ? void 0 : t.header.textColor,
      utmReferral: n
    },
    o
  )))), /* @__PURE__ */ e.createElement("div", { className: a.navbar__leftContainer__socialsWrapper }, c.map(({ url: l, img: o, rss: i }) => /* @__PURE__ */ e.createElement("a", { href: l, key: `${i}_${l}` }, o && /* @__PURE__ */ e.createElement("img", { className: a.navbar__leftContainer__socialsWrapperImg, src: o, alt: "social-icon" }), !o && /* @__PURE__ */ e.createElement(
    v,
    {
      fill: t == null ? void 0 : t.hightLighHightlight,
      rss: i,
      height: 30,
      width: 30
    }
  )))));
}
function W() {
  const {
    menu: r,
    logo: t
  } = m(), {
    close: n
  } = E(), {
    isDesktop: c
  } = _(), s = () => {
    n();
  };
  return /* @__PURE__ */ e.createElement("div", { className: a.navbar__leftContainer }, t && /* @__PURE__ */ e.createElement(
    "div",
    {
      onClick: () => s(),
      style: {
        cursor: "pointer"
      }
    },
    /* @__PURE__ */ e.createElement("img", { alt: "logo", src: t.image })
  ), r && c && /* @__PURE__ */ e.createElement(d, null));
}
export {
  W as LeftSideMenu
};
//# sourceMappingURL=LeftSideMenu.js.map
